<template>
	<div>
		<xl-drawer v-model="visible" :size="$lang() === 'zh-cn' ? '450px' : '510px'" :with-header="false" v-if="show">
			<preprint-list @toggle="handleToggle" :visible="visible"></preprint-list>
		</xl-drawer>
		<floating-btn @trigger="handelTrigger" v-show="!visible"></floating-btn>
	</div>
</template>

<script setup>
import { XlDrawer } from "@shining3d/ui-components";
import FloatingBtn from "./floatingBtn.vue";
import PreprintList from "./preprintList.vue";
import { ref, watch, onMounted, nextTick, onUnmounted } from "vue";
import { $lang } from '@shining3d/common-module/utils/index.js';
import Bus from '../../utils/bus.js';
import router from "@/router";

const visible = ref( false );
const show = ref( true );

watch(() => router.currentRoute.value , ( newVal ) => {
	if ( newVal.name === 'orderDetail' && newVal.query.type === 'dataDownload' ){
		show.value = false; // 订单详情、数据下载页不加载抽屉
	} else {
		show.value = true;
		visible.value = false;
	}
}, { immediate: true, deep: true });

Bus.$on( 'preprintPanelVisible', ( val ) => {
	visible.value = val;
});

const handelTrigger = () => {
	if( show.value ){ // 只对内部list生效 按钮只在visible = false时显示，默认置为true
		visible.value = true;
	}
};

const handleToggle = ( flag ) => {
	visible.value = flag;
};

Bus.$on( 'togglePreprintPanel', () => {
	if ( !show.value ){ // 只对外部list生效
		visible.value = true;
	}
});


onMounted(() => {
	visible.value = true;
	nextTick(() => {
		visible.value = false;
	})
})

onUnmounted(() => {
	Bus.$off( 'addPreprintItem' );
	Bus.$off( 'preprintPanelVisible' );
})

</script>

<style lang="scss" scoped>
:deep( .xl-drawer ) {
	.el-drawer__body {
		padding: 0 24px;
	}
}
</style>
